<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Clone Grade</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign From:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <CampaignAutocomplete
                :key="companySearchComponentFromKey"
                class="searchbox"
                :list="searchCampaign"
                :searchOn="'campaign'"
                @event-name="campaignFrom"
              ></CampaignAutocomplete>
            </div>
            <span
              class="text-danger text-sm mt-3"
              v-show="campaign_required_from"
              >{{ campaign_required_from }}
            </span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign To:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <CampaignAutocomplete
                :key="companySearchComponentToKey"
                class="searchbox"
                :list="searchCampaign"
                :searchOn="'campaign'"
                @event-name="campaignTo"
              ></CampaignAutocomplete>
            </div>
            <span class="text-danger text-sm mt-3" v-show="campaign_required_to"
              >{{ campaign_required_to }}
            </span>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Clone</vs-button
              >
            </div>
          </div>
          <vs-divider class="m-5" />
        </vx-card>
      </form>
    </div>
    <vs-popup
      :title="'Column Not Exists In ' + selected_campaign_to.campaign_name"
      :active.sync="columnNotExistsPopUp"
    >
      <h5>
        <vs-row>
          <div class="vx-row w-full m-6">
            <h4 class="text-center">Columns:</h4>
            <div
              class="vx-col w-full p-2"
              v-for="(column, index) in column_not_exists"
            >
              {{ index + 1 }} . {{ column }}
            </div>
          </div>
        </vs-row>
      </h5>
    </vs-popup>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleGradeManagement from "@/store/grade-management/moduleGradeManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {},
  data() {
    return {
      column_not_exists: [],
      columnNotExistsPopUp: false,
      campaign_required_to: null,
      campaign_required_from: null,
      selected_campaign_to: [],
      selected_campaign_from: [],
      companySearchComponentFromKey: 0,
      companySearchComponentToKey: 0,
      allGrades: [],
      abilities: null,
      grades: {
        grade: 0,
        description: null,
        grade_steps: [],
        campaign: []
      },
      all_grade_steps: []
    };
  },
  components: {
    "v-select": vSelect,
    moduleGradeManagement,
    CampaignAutocomplete
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule("GradesManagement", moduleGradeManagement);
      moduleGradeManagement.isRegistered = true;
    }

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  mounted() {},
  watch: {},
  methods: {
    getAllGradeSteps() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllGradeSteps",
          this.selected_campaign_to
        )
        .then(response => {
          self.all_grade_steps = response.data;
          console.log("All Grade Step", self.all_grade_steps);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    campaignFrom() {
      let self = this;
      let result = moduleCampaignManagement.state.campaign.datas;
      self.selected_campaign_from = result[0];
      self.grades.campaign = self.selected_campaign_from;
    },
    campaignTo() {
      let self = this;
      let result = moduleCampaignManagement.state.campaign.datas;
      self.selected_campaign_to = result[0];
      self.grades.campaign = self.selected_campaign_to;
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                } 
                // else {
                //   mappedArray.push({
                //     id: data[property].id,
                //     name: data[property].company_name + " (Client)",
                //     type: "client"
                //   });
                // }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      if (this.selected_campaign_from == "") {
        this.campaign_required_from =
          "Please select a campaign from which it should be cloned.";
        return false;
      }
      if (this.selected_campaign_to == "") {
        this.campaign_required_to =
          "Please select a campaign to which it should be cloned.";
        return false;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.cloneGrade();
        }
      });
    },
    cloneGrade() {
      let campaign_clone = {};
      campaign_clone.selected_campaign_from = this.selected_campaign_from;
      campaign_clone.selected_campaign_to = this.selected_campaign_to;

      this.$store
        .dispatch("GradesManagement/cloneGrade", campaign_clone)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Grades Exists",
              text: res.data.message
            });
          } else if (res.data.status == "column_failed") {
            this.$vs.notify({
              color: "success",
              title: "Column doesn't exists",
              text: res.data.message
            });
            this.column_not_exists = res.data.data;
            this.columnNotExistsPopUp = true;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Grades Cloned",
              text: "Grades Succesfully cloned."
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
